'use client'

import Script from 'next/script'
import DOMPurify from 'isomorphic-dompurify'

export default function AnalyticsLoader() {
  const GTM_ID      = process.env.NEXT_PUBLIC_GTM_KEY
  const GA_ID       = process.env.NEXT_PUBLIC_GA_ID
  const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FB_PIXEL_ID
  // Only culineerapp.com (production) reports to GTM/GA4/FB Pixel — dev/staging/
  // local traffic must never mix into real user analytics.
  const IS_PROD     = process.env.NEXT_PUBLIC_APP_URL === 'https://culineerapp.com'

  return (
    <>
      {GTM_ID && IS_PROD && (
        <Script
          id="gtm-script"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(`
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','${GTM_ID}');
            `),
          }}
        />
      )}

      {GA_ID && IS_PROD && (
        <>
          <Script
            src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
            strategy="afterInteractive"
          />
          <Script
            id="ga4-init"
            strategy="afterInteractive"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(`
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', '${GA_ID}', {
                  page_path: window.location.pathname,
                  anonymize_ip: true,
                });
              `),
            }}
          />
        </>
      )}

      {FB_PIXEL_ID && IS_PROD && (
        <Script
          id="fb-pixel"
          strategy="afterInteractive"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(`
              !function(f,b,e,v,n,t,s){
                if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;
                s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)
              }(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
              fbq('init', '${FB_PIXEL_ID}');
              fbq('track', 'PageView');
            `),
          }}
        />
      )}

    </>
  )
}
